import React from 'react';

/**
 * Unified Loader Component
 * Loading spinner with optional text
 */
const Loader = ({ 
  size = 'md', // sm, md, lg
  text = '',
  fullScreen = false,
  color = 'primary' // primary, secondary, white
}) => {
  const sizeStyles = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16'
  };
  
  const colorStyles = {
    primary: 'border-primary-600',
    secondary: 'border-secondary-600',
    white: 'border-white'
  };
  
  const spinner = (
    <div className="flex flex-col items-center justify-center gap-4">
      <div className={`${sizeStyles[size]} border-4 ${colorStyles[color]} border-t-transparent rounded-full animate-spin`} />
      {text && (
        <p className="text-slate-300 text-sm font-medium animate-pulse">
          {text}
        </p>
      )}
    </div>
  );
  
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-slate-900/80 backdrop-blur-sm flex items-center justify-center z-50">
        {spinner}
      </div>
    );
  }
  
  return spinner;
};

export default Loader;
